const initialState = {
	rowsPerPage: {
		users: 10,
		alerts: 10,
		registrationList: 10,
	}
};

const settingsReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_NUMBER_ROWS_PER_PAGE':
			return {
				...state,
				rowsPerPage: {
					...state.rowsPerPage,
					[action.payload.value.table]: action.payload.value.rowsPerPage
				}
			};

		default:
			return state;
	}
};

export const setNumberRowsPerPageActionCreator = (value) => ({
	type: 'SET_NUMBER_ROWS_PER_PAGE',
	payload: {
		value
	}
});

export default settingsReducer;
